import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const ChevronDownIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M18 9.00005C18 9.00005 13.5811 15 12 15C10.4188 15 6 9 6 9" stroke="currentColor" />
    </SvgIcon>
  )
}
